import {Component, OnInit} from '@angular/core';
import {SmartTableConfigInterface} from '../../../../shared/interface';
import {MatDialog} from '@angular/material/dialog';

import {ActivatedRoute} from '@angular/router';
import {MarketingItemService} from '../../../../shared/service/marketing-item.service';
import {MarketingItemModel} from '../../../../shared/models/marketing-item.model';
import {MarketingItemsModel} from '../../../../shared/models/marketing-items.model';
import {MarketingItemModalComponent} from '../../../../shared/modal/marketing-item-modal/marketing-item-modal.component';

@Component({
  selector: 'app-marketing-item-manager-page',
  templateUrl: './marketing-item-manager-page.component.html',
  styleUrls: ['./marketing-item-manager-page.component.scss']
})
export class MarketingItemManagerPageComponent implements OnInit {


  tableData: MarketingItemsModel;
  selectedMarketingItem: MarketingItemModel;
  smartTableConfig: SmartTableConfigInterface;


  constructor(public dialog: MatDialog, private marketingItemsService: MarketingItemService, private activatedRoute: ActivatedRoute) {

    this.initSmartTable();
    this.marketingItemsService.marketingItems.subscribe((marketingItems: MarketingItemsModel) => {
      this.tableData = marketingItems;
    });

    this.marketingItemsService.selectedMarketingItem.subscribe((marketingItem: MarketingItemModel) => {
      this.selectedMarketingItem = marketingItem;
    });
  }

  ngOnInit() {
    this.activatedRoute.data.subscribe(
      (data: { marketingItemsResolver: any }) => {
        this.tableData.items = data.marketingItemsResolver;
      }
    );
  }

  initSmartTable() {
    this.smartTableConfig = {
      columns: [
        {labelKey: 'MARKETING.ADMIN.TITLE', dataKey: 'title'},
        {labelKey: 'MARKETING.ADMIN.DESCRIPTION', dataKey: 'description'}
      ],
      displayedColumns: ['title', 'description']
    };
  }


  openDialog(selectedMarketingModel?: MarketingItemModel) {

    this.dialog.open(MarketingItemModalComponent, {
      hasBackdrop: true,
      width: '60vw',
      data: selectedMarketingModel ? selectedMarketingModel : new MarketingItemModel()
    });

  }


  deleteItem(event) {
    this.marketingItemsService.deleteMarketingItemItem(event.item, event.dialogRef);
  }

}
